import React from 'react';
import { Page, Content, Header } from '@backstage/core-components';

export const DocusaurusDocsPage = () => (
  <Page themeId="documentation">
    <Header title="Developer Documentation" 
      //subtitle="Docusaurus site" 
    />
    <Content>
      <iframe
        src="https://dev.d2vp8y3pggxh9u.amplifyapp.com/docs/" // or your proxy URL        
        style={{ border: 0, width: '100%', height: 'calc(100vh - 160px)' }}
        title="Developer Documentation"
      />
    </Content>
  </Page>
);
